import React from 'react';
import { AlertTriangle } from 'lucide-react';
import Modal from './Modal';

const variantStyles = {
  danger: {
    iconWrap: 'bg-red-100 text-red-600',
    confirmButton: 'btn-danger',
  },
  warning: {
    iconWrap: 'bg-amber-100 text-amber-600',
    confirmButton: 'btn-primary',
  },
  primary: {
    iconWrap: 'bg-primary-100 text-primary-600',
    confirmButton: 'btn-primary',
  },
};

const ConfirmModal = ({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  loading = false,
  onClose,
  onConfirm,
}) => {
  const styles = variantStyles[variant] || variantStyles.danger;

  return (
    <Modal isOpen={isOpen} onClose={loading ? undefined : onClose} size="sm">
      <div className="px-5 py-6 text-center sm:px-6">
        <div className={`mx-auto flex h-12 w-12 items-center justify-center rounded-full ${styles.iconWrap}`}>
          <AlertTriangle className="h-6 w-6" />
        </div>

        <h3 className="mt-4 text-lg font-semibold text-gray-900">{title}</h3>
        {message ? (
          <div className="mt-2 text-sm leading-6 text-gray-600">
            {typeof message === 'string' ? <p>{message}</p> : message}
          </div>
        ) : null}

        <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-center">
          <button type="button" className="btn-secondary" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </button>
          <button type="button" className={styles.confirmButton} onClick={onConfirm} disabled={loading}>
            {loading ? 'Please wait...' : confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
